import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DataSource } from '@angular/cdk/table';

import { CollectionViewer } from '@angular/cdk/collections';
// tslint:disable-next-line:import-blacklist
import {  BehaviorSubject ,  Observable, fromEvent ,  of } from 'rxjs';

import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
import { catchError, finalize, map, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ReimburseDialogComponent } from '../reimburse-dialog/reimburse-dialog.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ChangeInvoiceStatusDialogComponent } from '../change-invoice-status-dialog/change-invoice-status-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-jaldee-report',
  templateUrl: './jaldee-report.component.html',
  styleUrls: ['./jaldee-report.component.css']
})

export class JaldeeReportComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  dataSource = new JaldeeReportDataSource( this.jaldeeReportService);
  displayedColumns: string[] = ['invoiceId', 'fromDate' , 'toDate' , 'accountId', 'accountName',
  'jaldeeBank', 'jaldeereim','jaldeeCoupon', 'reimburse_amt', 'invoiceStatus'];
  selectedRowIndex = -1;
  report: any;
  showToolBar = false;
  tableFilters = '';
  @ViewChild('go', {static: false}) button: ElementRef;
  reportCount = 10;
  showInvoiceBtn = false;
  subDomains: any[];
  serviceSectors: any;
  domain: any;
  fromDate;
  toDate;
  collapsed;
  baseLocationModel;
  baseLocation;
  reimburseid;

  showChangeInvoiceStatusBtn = false;
  configData: any = {};
  jaldeeReimburseStatus: any = [];
  ReportStatus: any = [];
  showReimburse = true;

  // tslint:disable-next-line: max-line-length
  constructor(private jaldeeReportService: JaldeeReportService, private dialog: MatDialog, private commonFilter: CommonfilterService, private router: Router, private activatedRoute: ActivatedRoute,
     private activatedRoot: ActivatedRoute ,
     private locObj: Location) {
   this.commonFilter.getConfigData()
   .subscribe(res => {
     this.configData = res;
     console.log( this.configData);
     this.jaldeeReimburseStatus = this.configData.jaldeeInvoiceStatus;
     this.ReportStatus = this.configData.reportStatusDetails;
   });
   this.commonFilter.getS3UrlFromBackend()
   .subscribe(res => {
     this.commonFilter.setS3Url(res);
   });
   this.activatedRoot.params.subscribe(data => {
    this.reimburseid = data;
    console.log(this.reimburseid);
    });
   }
  ngOnInit() {
    this.dataSource.loadJaldeeReport(this.tableFilters, 'false', 0, 100 , this.reimburseid);
    this.getTotalCountByFilters(this.tableFilters , this.reimburseid);
  }

  onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      // tslint:disable-next-line:triple-equals
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({'displayName': this.serviceSectors[i].subDomains[j].displayName,
           'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain});
          }
        }
      }
    }
  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadReportsPage())
    )
    .subscribe();

    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commonFilter.createfilterParams('report');
            // console.log('table filterss....' + this.tableFilters);
           this.getTotalCountByFilters(this.tableFilters , this.reimburseid);
            this.paginator.pageIndex = 0;
            this.loadReportsPage();


        })
    )
    .subscribe();

}
getTotalCountByFilters(filter , reimburseid) {
 // console.log('filters...' + filter);
  this.jaldeeReportService.getTotalFilterCount(filter , reimburseid)
  .subscribe( data => this.reportCount = data);
 }

loadReportsPage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadJaldeeReport(

    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize,
    this.reimburseid
    );
}

  onReportCliked(row) {
    this.showInvoiceBtn = false;
    this.showToolBar = false;
    this.showReimburse = true;
    this.showChangeInvoiceStatusBtn = false;
    this.selectedRowIndex = row.invoiceId;
    console.log('row status........' + row.status);
    if (row.status === 'INDISPUTE') {
          this.showReimburse = false;
          this.showInvoiceBtn = true;

      }
      if(row.grantTotal < 0 ){
        this.showReimburse = false;
      }
      if (row.status === 'PAYMENTPENDING') {
        this.showInvoiceBtn = true;
      }
    this.report = row;
    console.log(this.report);
    this.showToolBar = true;
  }
  reimburse() {
    const dialogReference = this.dialog.open(ReimburseDialogComponent, {
      width : '1000px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  reportback() {
    this.locObj.back();
  }
  changeInvoiceStatus() {
    const dialogReference = this.dialog.open(ChangeInvoiceStatusDialogComponent, {
      width : '900px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  }




export class JaldeeReportDataSource extends DataSource<any> {


  private jaldeeReportSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor( private reportService: JaldeeReportService) {
    super();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.jaldeeReportSubject.complete();
    this.loadingSubject.complete();
  }
  connect(): Observable<any> {
    return this.jaldeeReportSubject.asObservable();
  }


  loadJaldeeReport( filter,
    sortDirection, count, pageSize , reimburseid) {
    this.loadingSubject.next(true);
    this.reportService.getReports( filter, sortDirection,
      count, pageSize , reimburseid).pipe(
       catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(reports =>
         this.jaldeeReportSubject.next(reports)
         );
    }
}
